import { request } from "./http";

export const listAvailableSlots = (start: string) =>
  request<{
    start: string;
    count: number;
    limit: number | null;
    available: boolean;
  }[]>(`/api/available-slots?start=${start}`);

